export default "__VITE_ASSET__BkoMOEmT__"